import { render, staticRenderFns } from "./ApiMarket.vue?vue&type=template&id=04685f0d&scoped=true"
import script from "./ApiMarket.vue?vue&type=script&lang=js"
export * from "./ApiMarket.vue?vue&type=script&lang=js"
import style0 from "./ApiMarket.vue?vue&type=style&index=0&id=04685f0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04685f0d",
  null
  
)

export default component.exports